import { createContext } from 'react';

import { InputValueType, RadioChangeEvent } from './interfaces';

export interface RadioGroupContextProps {
  onChange: (e: RadioChangeEvent) => void;
  value: InputValueType;
  disabled?: boolean;
}

const RadioGroupContext = createContext<RadioGroupContextProps | null>(null);

export const RadioGroupContextProvider = RadioGroupContext.Provider;
export default RadioGroupContext;
